import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SecureLS from "secure-ls";
import { NotificationContextProvider } from "../modules/System/Components/Notification/NotificationContext";
import RouteLoadingScreen from "../modules/System/Components/Loading/RouteLoadingScreen";
import { AdminRoutes } from "./routesAdmin"; 

const ls = new SecureLS({ isCompression: false });
const Login = lazy(() => import("./Auth/Login"));
const Signup = lazy(() => import("./Auth/Signup"));
const Home = lazy(() => import("./Game/Home"));
const LandingPage = lazy(() => import("./LandingPage/LandingPage"));

const getStoredUserId = () => {
  try {
    return String(ls.get("userDetails")?.userId || "").trim();
  } catch (_error) {
    return "";
  }
};

const HomeRoute = () => {
  const userId = getStoredUserId();
  return (
    <NotificationContextProvider userId={userId}>
      <Home />
    </NotificationContextProvider>
  );
};

const DefaultRedirect = () => (
  <Navigate to={getStoredUserId() ? "/home" : "/"} replace />
);

const AppRoutes = () => {
  const homeElement = <HomeRoute />;

  return (
    <Suspense fallback={<RouteLoadingScreen />}>
      <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/hoard/shop" element={<Navigate to="/skills" replace />} />
      <Route path="/hoard/*" element={homeElement} />
      <Route path="/skills/*" element={homeElement} />
      <Route path="/gather" element={homeElement} />
      <Route path="/process" element={homeElement} />
      <Route path="/craft" element={homeElement} />
      <Route path="/fish" element={homeElement} />
      <Route path="/forage" element={homeElement} />
      <Route path="/farm" element={homeElement} />
      <Route path="/animal" element={homeElement} />
      <Route path="/ranch" element={homeElement} />
      <Route path="/event" element={homeElement} />
      <Route path="/event/newyear2025" element={homeElement} />
      <Route path="/event/lunarnewyear2026" element={homeElement} />
      <Route path="/event/earthprotection2026" element={homeElement} />
      <Route path="/event/foolchaos2026" element={homeElement} />
      <Route path="/event/mayscraprallyderby2026" element={homeElement} />
      <Route path="/event/slotsofluck2026" element={homeElement} />
      <Route path="/event/summertidesfestival2026" element={homeElement} />
      <Route path="/cooking" element={homeElement} />
      <Route path="/woodcutting" element={homeElement} />
      <Route path="/cards" element={homeElement} />
      <Route path="/mining/*" element={homeElement} />
      <Route path="/herbalism" element={homeElement} />
      <Route path="/dungeons" element={homeElement} />
      <Route path="/home" element={homeElement} />
      <Route path="/inventory" element={homeElement} />
      <Route path="/shop" element={<Navigate to="/skills" replace />} />
      <Route path="/market" element={homeElement} />
      <Route path="/profile" element={homeElement} />
      <Route path="/leaderboard/*" element={homeElement} />
      <Route path="/friends" element={homeElement} />
      <Route path="/admin-tab" element={homeElement} />
      {AdminRoutes()}
        <Route path="*" element={<DefaultRedirect />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
